import { Input } from "@/components/ui/input";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setFilters } from "../products.slice";
import React, { useState, useEffect } from "react";

export default function ProductsSearch() {
  // Hooks
  const dispatch = useAppDispatch();

  // Redux
  const { filters } = useAppSelector((state) => state.products);

  // Local state for input
  const [searchValue, setSearchValue] = useState(filters.search);

  // Debounce effect
  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchValue !== filters.search) {
        dispatch(setFilters({ ...filters, search: searchValue }));
      }
    }, 300);
    return () => clearTimeout(handler);
  }, [searchValue]);

  useEffect(() => {
    setSearchValue(filters.search);
  }, [filters.search]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  return (
    <Input
      className="w-xs"
      placeholder="Search Product"
      value={searchValue}
      onChange={handleSearch}
    />
  );
}
